const loading = {
  v: '5.6.9',
  fr: 29.9700012207031,
  ip: 0,
  op: 62.0000025253118,
  w: 280,
  h: 280,
  nm: 'Comp 3',
  ddd: 0,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'voice Outlines',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [140, 140, 0], ix: 2 },
            a: { a: 0, k: [270, 270, 0], ix: 1 },
            s: { a: 0, k: [94, 94, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0.022, 0],
                        [0, 0],
                        [0, 0.023],
                        [0, 0],
                        [-0.021, 0.002],
                        [0, 0],
                        [0, 7.956],
                        [0, 0],
                        [0.023, 0],
                        [0, 0],
                        [0, -0.023],
                        [0, 0],
                        [7.542, -0.351],
                        [0, 7.94],
                        [0, 0],
                        [0.022, 0],
                        [0, 0],
                        [0, -0.023],
                        [0, 0],
                        [-7.895, -0.994],
                        [0, 0],
                        [0, -0.021],
                        [0, 0],
                        [0.023, 0],
                        [0, 0],
                        [0, -0.023],
                        [0, 0],
                        [-0.023, 0],
                        [0, 0],
                        [0, 0.022],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-0.023, 0],
                        [0, 0],
                        [0, -0.021],
                        [0, 0],
                        [7.893, -0.994],
                        [0, 0],
                        [0, -0.023],
                        [0, 0],
                        [-0.023, 0],
                        [0, 0],
                        [0, 7.55],
                        [-8.022, 0.374],
                        [0, 0],
                        [0, -0.023],
                        [0, 0],
                        [-0.023, 0],
                        [0, 0],
                        [0, 7.958],
                        [0, 0],
                        [0.021, 0.002],
                        [0, 0],
                        [0, 0.023],
                        [0, 0],
                        [-0.023, 0],
                        [0, 0],
                        [0, 0.022],
                        [0, 0],
                        [0.022, 0],
                        [0, 0],
                        [0, -0.023],
                      ],
                      v: [
                        [10.752, 11.56],
                        [0.917, 11.56],
                        [0.876, 11.518],
                        [0.876, 6.398],
                        [0.912, 6.358],
                        [1.936, 6.228],
                        [15.75, -9.435],
                        [15.75, -13.268],
                        [15.708, -13.31],
                        [14.042, -13.31],
                        [14, -13.268],
                        [14, -9.841],
                        [0.668, 4.585],
                        [-14, -9.398],
                        [-14, -13.268],
                        [-14.041, -13.31],
                        [-15.708, -13.31],
                        [-15.75, -13.268],
                        [-15.75, -9.438],
                        [-1.933, 6.228],
                        [-0.912, 6.358],
                        [-0.875, 6.398],
                        [-0.875, 11.518],
                        [-0.917, 11.56],
                        [-10.749, 11.56],
                        [-10.791, 11.603],
                        [-10.791, 13.27],
                        [-10.749, 13.31],
                        [10.752, 13.31],
                        [10.793, 13.27],
                        [10.793, 11.603],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0.301384151683, 0.525550034467, 0.973881740196, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [270, 284.189], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-5.442, 0],
                        [0, 5.439],
                        [0, 0],
                        [5.439, 0],
                        [0, -5.439],
                        [0, 0],
                      ],
                      o: [
                        [5.439, 0],
                        [0, 0],
                        [0, -5.439],
                        [-5.442, 0],
                        [0, 0],
                        [0, 5.439],
                      ],
                      v: [
                        [0.001, 20.946],
                        [9.866, 11.081],
                        [9.866, -11.08],
                        [0.001, -20.946],
                        [-9.866, -11.08],
                        [-9.866, 11.081],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0.301384151683, 0.525550034467, 0.973881740196, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [270, 263.447], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, -39.488],
                        [39.488, 0],
                        [0, 39.488],
                        [-39.488, 0],
                      ],
                      o: [
                        [0, 39.488],
                        [-39.488, 0],
                        [0, -39.488],
                        [39.488, 0],
                      ],
                      v: [
                        [71.5, 0],
                        [0, 71.5],
                        [-71.5, 0],
                        [0, -71.5],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0.301384151683, 0.525550034467, 0.973881740196, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [270, 270], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 3',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 900.000036657751,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Base Layer 4',
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 20, s: [49] },
                { t: 45.0000018328876, s: [0] },
              ],
              ix: 11,
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [139.029, 140.234, 0], ix: 2 },
            a: { a: 0, k: [9.953, -2.402, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
                  t: 0,
                  s: [31.532, 31.532, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
                  t: 20,
                  s: [69.368, 69.368, 100],
                },
                { t: 45.0000018328876, s: [84.882, 84.882, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  d: 1,
                  ty: 'el',
                  s: { a: 0, k: [331.855, 331.855], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: 'Ellipse Path 1',
                  mn: 'ADBE Vector Shape - Ellipse',
                  hd: false,
                },
                {
                  ty: 'st',
                  c: { a: 0, k: [0.356862745098, 0.556862745098, 0.956862745098, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0.356862745098, 0.556862745098, 0.956862745098, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [11.178, -2.697], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [97.195, 97.195], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Ellipse 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 62.0000025253118,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Base Layer 3',
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 34, s: [27] },
                { t: 59.0000024031193, s: [0] },
              ],
              ix: 11,
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [140.971, 139.766, 0], ix: 2 },
            a: { a: 0, k: [12.553, -3.029, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
                  t: 14,
                  s: [31.532, 31.532, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 1] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
                  t: 34,
                  s: [69.368, 69.368, 100],
                },
                { t: 59.0000024031193, s: [84.882, 84.882, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  d: 1,
                  ty: 'el',
                  s: { a: 0, k: [331.855, 331.855], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: 'Ellipse Path 1',
                  mn: 'ADBE Vector Shape - Ellipse',
                  hd: false,
                },
                {
                  ty: 'st',
                  c: { a: 0, k: [0.356862745098, 0.556862745098, 0.956862745098, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0.356862745098, 0.556862745098, 0.956862745098, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [11.178, -2.697], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [97.195, 97.195], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Ellipse 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 62.0000025253118,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'Comp 1',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [140, 140, 0], ix: 2 },
        a: { a: 0, k: [140, 140, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 280,
      h: 280,
      ip: 0,
      op: 62.0000025253118,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
export default loading;
